import { useSearchParams } from '@remix-run/react';
import type { TLoginElement } from '@shared/dream-components';
import { LoginElement } from '@shared/dream-components';
import { type ReactNode, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import useGlobalModals from '~/components/GlobalModals/hooks/useGlobalModals';

import LoginAction from '~/components/LoginAction';

interface Props {
  node: TLoginElement;
  children: ReactNode | ReactNode[];
}

const Login = ({ node, children }: Props) => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();

  const { handleCloseModal, currentModal } = useGlobalModals();

  const handleSuccess = useCallback(() => {
    if (currentModal === 'login') {
      handleCloseModal({ preventScrollReset: true });
    }
  }, [currentModal, handleCloseModal]);

  return (
    <LoginAction onSuccess={handleSuccess}>
      {({ isLoading, canLogInWithPassword }) => (
        <LoginElement
          element={node}
          isSubmitting={isLoading}
          canLogInWithPassword={canLogInWithPassword}
          labels={{
            login_with_otp_label: t('login.login_with_otp_label'),
            login_with_email_label: t('login.login_with_email_label'),
            set_new_password: t('login.set_new_password'),
            login_with_password_label: t('login.login_with_password_label'),
            otp_label: t('login.otp_label'),
            resend_otp_button_label: t('login.resend_otp_button_label'),
          }}
          searchParams={searchParams}
        >
          {children}
        </LoginElement>
      )}
    </LoginAction>
  );
};

export default Login;
